module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(!_vm.resourceLoaded) ? _c('Loader') : _vm._e(), _vm._v(" "), (_vm.resourceLoaded) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "superconciergerie-table text-center table table-responsive",
    attrs: {
      "id": "dashboard-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("superconcierge.dashboard.rental_owner")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("superconcierge.dashboard.rental_name")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("superconcierge.dashboard.date")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("superconcierge.dashboard.arrivals")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("superconcierge.dashboard.departures")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t("superconcierge.dashboard.base_calculation")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t("superconcierge.dashboard.total_commission")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t("superconcierge.dashboard.total_cleaning")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t("superconcierge.dashboard.total_linen")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t("superconcierge.dashboard.total_checkin")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t("superconcierge.dashboard.total_fees")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredMappedRentals), function(rental) {
    return _c('tr', {
      key: rental.rental.id
    }, [_c('td', [_c('div', [_vm._v(_vm._s(rental.rental.owner.name))])]), _vm._v(" "), _c('td', [_c('div', [_c('a', {
      staticClass: "m-b-10 product-price action-title",
      attrs: {
        "href": '#/rentals/' + rental.rental.id,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(rental.name))])])]), _vm._v(" "), _c('td', [_c('div', [_vm._v("\n                  " + _vm._s(_vm.capitalize(_vm.moment(rental.year + "-" + rental.month).locale("fr").format("MMMM YYYY"))) + "\n                ")])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(rental.arrivals))])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(rental.departures))])]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v(_vm._s(rental.total_base_calculation.toFixed(2)) + _vm._s(rental.currency))])]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v(_vm._s(rental.total_commissions.toFixed(2)) + _vm._s(rental.currency))])]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "font-weight": "600"
      },
      attrs: {
        "id": 'rental-' + rental.rental.id + '-total_cleaning'
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showInputField(rental.rental, 'total_cleaning', 'rental-', _vm.updateRental, this)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(rental.total_cleaning.toFixed(2)) + _vm._s(rental.currency) + "\n                ")])]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "font-weight": "600"
      },
      attrs: {
        "id": 'rental-' + rental.rental.id + '-total_linen'
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showInputField(rental.rental, 'total_linen', 'rental-', _vm.updateRental, this)
        }
      }
    }, [_vm._v(_vm._s(rental.total_linen.toFixed(2)) + _vm._s(rental.currency))])]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "font-weight": "600"
      },
      attrs: {
        "id": 'rental-' + rental.rental.id + '-total_checkin'
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showInputField(rental.rental, 'total_checkin', 'rental-', _vm.updateRental, this)
        }
      }
    }, [_vm._v(_vm._s(rental.total_checkin.toFixed(2)) + _vm._s(rental.currency))])]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v(_vm._s(rental.total_fees.toFixed(2)) + _vm._s(rental.currency))])])])
  }))])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f77cb7b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/superconciergerie/tabs/DashboardTab.vue
// module id = 1398
// module chunks = 0